const actions = {
    GET_CRAWL_BOOKING_POSITION_REQUEST: "GET_CRAWL_BOOKING_POSITION_REQUEST",
    GET_CRAWL_BOOKING_POSITION_SUCCESS: "GET_CRAWL_BOOKING_POSITION_SUCCESS",
    GET_CRAWL_BOOKING_POSITION_ERROR: "GET_CRAWL_BOOKING_POSITION_ERROR",

    CRAWL_BOOKING_POSITION_REQUEST: "CRAWL_BOOKING_POSITION_REQUEST",
    CRAWL_BOOKING_POSITION_SUCCESS: "CRAWL_BOOKING_POSITION_SUCCESS",
    CRAWL_BOOKING_POSITION_ERROR: "CRAWL_BOOKING_POSITION_ERROR",

    GET_EXCEL_BOOKING_POSITION_REQUEST: "CRAWL_BOOKING_POSITION/GET_EXCEL_BOOKING_POSITION_REQUEST",
    GET_EXCEL_BOOKING_POSITION_SUCCESS: "CRAWL_BOOKING_POSITION/GET_EXCEL_BOOKING_POSITION_SUCCESS",
    GET_EXCEL_BOOKING_POSITION_ERROR: "CRAWL_BOOKING_POSITION/GET_EXCEL_BOOKING_POSITION_ERROR",

    DELETE_EXCEL_STORE_BOOKING_POSITION_REQUEST: "CRAWL_BOOKING_POSITION/DELETE_INFORMATION_STORE_BOOKING_POSITION_REQUEST",
    DELETE_EXCEL_BOOKING_POSITION_SUCCESS: "CRAWL_BOOKING_POSITION/DELETE_INFORMATION_STORE_BOOKING_POSITION_SUCCESS",
    DELETE_EXCEL_BOOKING_POSITION_ERROR: "CRAWL_BOOKING_POSITION/DELETE_INFORMATION_STORE_BOOKING_POSITION_ERROR",

    crawlBookingPosition: (payload) => ({
        type: actions.CRAWL_BOOKING_POSITION_REQUEST,
        payload,
    }),

    getCrawlBookingPosition: (payload) => ({
        type: actions.GET_CRAWL_BOOKING_POSITION_REQUEST,
        payload,
    }),

    getInformationStore: () => ({
        type: actions.GET_EXCEL_BOOKING_POSITION_REQUEST,
    }),

    deleteInformationStore: (payload) => ({
        type: actions.DELETE_EXCEL_STORE_BOOKING_POSITION_REQUEST,
        payload,
    }),
};
export default actions;